import _extends from "@babel/runtime/helpers/esm/extends";
import { Box } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import Button from "../../../atoms/Button";
import Typography from "../../../atoms/Typography";
import { checkLocaleHkTw } from "../../EStoreBestsellerHome/PopularCard";
import colors from "../../../theme/colors";
import Tabs from "../../EStoreProduct/ProductItem/Tabs";
import { WrapperContainer } from "../Option";
import FreeGift from "../Option/FreeGift";
import Platform from "./Platform";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function OptionDLC(props) {
  const {
    tabList,
    title,
    platform,
    itemPlatformSelect,
    onSelectPlatform,
    buttonPropsBuyDLC,
    padding = 0,
    price,
    freeGift,
    isSoldOut,
    locale,
    titleSale,
    salePrice,
    titleTaxForTC
  } = props;
  const refWrapper = useRef();
  useEffect(() => {
    if (typeof window !== "undefined") {
      const wrapper = refWrapper.current;
      if (wrapper) {
        window.addEventListener("resize", () => {
          wrapper?.scrollTo({
            left: 0,
            behavior: "smooth"
          });
        });
      }
    }
    ;
    return () => {
      window.removeEventListener("resize", () => {});
    };
  }, []);
  const handelReturnCheckDisable = () => {
    if (isSoldOut) {
      return true;
    }
    const result = false;
    if (!itemPlatformSelect?.id) {
      return true;
    }
    return result;
  };
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      marginLeft: {
        xs: "0px",
        lg: "56px"
      },
      marginTop: {
        xs: "40px",
        lg: "0px"
      },
      width: "100%"
    },
    children: [WrapperContainer( /*#__PURE__*/_jsxs(React.Fragment, {
      children: [!!tabList?.length && /*#__PURE__*/_jsx(Box, {
        sx: {
          width: "100%",
          marginBottom: "4px"
        },
        children: /*#__PURE__*/_jsx(Tabs, {
          tabList: tabList || []
        })
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "h4",
        sx: {
          WebkitLineClamp: 2,
          display: '-webkit-box',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          WebkitBoxOrient: 'vertical'
        },
        children: title
      })]
    })), !isSoldOut && /*#__PURE__*/_jsxs(Box, {
      sx: {
        display: "flex",
        flexDirection: "column",
        paddingTop: {
          xs: "48px",
          lg: "64px"
        }
      },
      children: [WrapperContainer( /*#__PURE__*/_jsx(Typography, {
        color: colors.neutral.neutral2,
        variant: "p5",
        sx: {
          marginBottom: "14px"
        },
        children: platform?.title
      })), /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: "flex",
          flexWrap: {
            xs: "nowrap",
            lg: "wrap"
          },
          gap: "14px",
          overflow: "auto",
          overflowX: {
            xs: "scroll",
            ld: "auto"
          },
          scrollSnapType: "x mandatory",
          WebkitOverflowScrolling: "touch",
          overscrollBehaviorX: "contain",
          "&::-webkit-scrollbar": {
            display: "none"
          }
        },
        ref: refWrapper,
        children: [!!platform?.platformList?.length && platform?.platformList.map((item, index) => {
          return /*#__PURE__*/_jsx(Box, {
            sx: {
              display: "inline-block",
              scrollSnapAlign: "start"
            },
            children: /*#__PURE__*/_jsx(Box, {
              sx: {
                transform: {
                  xs: `translateX(${padding + 16}px)`,
                  md: `translateX(${padding}px)`
                }
              },
              children: /*#__PURE__*/_jsx(Platform, {
                isSelect: itemPlatformSelect?.id === item?.id,
                titleIcon: item?.value,
                onClick: () => {
                  onSelectPlatform?.(item);
                }
              })
            })
          }, index);
        }), /*#__PURE__*/_jsx(Box, {
          sx: {
            display: "inline-block",
            scrollSnapAlign: "start"
          },
          children: /*#__PURE__*/_jsx(Box, {
            sx: {
              transform: {
                xs: `translateX(${padding + 16}px)`,
                md: `translateX(${padding}px)`
              }
            },
            children: /*#__PURE__*/_jsx(Box, {
              sx: {
                display: "inline-block",
                width: `${padding}px`,
                height: "100%",
                background: "red"
              }
            })
          })
        })]
      })]
    }), !isSoldOut && WrapperContainer( /*#__PURE__*/_jsx(FreeGift, _extends({}, freeGift))), WrapperContainer( /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsx(Box, {
        sx: {
          width: "100%",
          display: "flex",
          flexDirection: "column"
        },
        children: /*#__PURE__*/_jsxs(Box, {
          sx: {
            width: "100%",
            display: "flex",
            justifyContent: "flex-start",
            flexDirection: "column",
            paddingTop: isSoldOut ? {
              xs: "48px",
              lg: "64px"
            } : "44px"
          },
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "h6",
            color: colors.primary.bandaiNamcoBlack,
            children: price
          }), !!salePrice && /*#__PURE__*/_jsxs(Box, {
            sx: {
              display: "flex"
            },
            children: [/*#__PURE__*/_jsx(Typography, {
              color: "#737373",
              sx: {
                textDecoration: "line-through",
                fontSize: {
                  xs: "10px",
                  md: "16px"
                },
                lineHeight: {
                  xs: "12px",
                  md: "22px"
                },
                fontWeight: "600"
              },
              children: salePrice
            }), titleSale && /*#__PURE__*/_jsx(Typography, {
              color: "#DF4662",
              sx: {
                textTransform: "lowercase",
                marginLeft: {
                  xs: "4px",
                  md: "8px"
                },
                fontSize: {
                  xs: "10px",
                  md: "16px"
                },
                lineHeight: {
                  xs: "12px",
                  md: "22px"
                },
                fontWeight: "600"
              },
              children: titleSale
            })]
          }), checkLocaleHkTw(locale) && /*#__PURE__*/_jsx(Typography, {
            variant: "p9",
            color: "#1E1E1E",
            sx: {
              marginTop: "4px",
              fontSize: {
                md: "12px",
                xs: "10px"
              }
            },
            children: titleTaxForTC
          })]
        })
      }), /*#__PURE__*/_jsx(Box, {
        sx: {
          width: "100%",
          display: "flex",
          flexDirection: "column",
          paddingTop: "48px"
        },
        children: /*#__PURE__*/_jsx(Button, _extends({}, buttonPropsBuyDLC, {
          variant: handelReturnCheckDisable() ? "primary" : buttonPropsBuyDLC?.variant,
          disabled: handelReturnCheckDisable(),
          onClick: e => {
            buttonPropsBuyDLC?.onClick?.(e);
          }
        }))
      })]
    }))]
  });
}